// Single source of truth for the colors that distinguish the three event
// types on the Events tab (tournaments / trainings / challenges) and the
// three place types on the Map tab (outdoor / indoor / store).
//
// Both the list/calendar badges and the filter chips read from here, so a
// colour bump is one diff not five.

import type { PlaceType } from "@/types/api";

export type EventKind = "tournament" | "training" | "challenge";

export const EVENT_COLOR: Record<EventKind, string> = {
  tournament: "#FF5A1F", // brand orange
  training: "#1E7A5A",   // court green
  challenge: "#8B5CF6",  // violet
};

// Soft tint used for idle filter chips and subtle backgrounds. Alpha kept
// low enough to stay readable on top of the app background.
export const EVENT_COLOR_SOFT: Record<EventKind, string> = {
  tournament: "rgba(255,90,31,0.12)",
  training: "rgba(30,122,90,0.14)",
  challenge: "rgba(139,92,246,0.14)",
};

export const EVENT_LABEL: Record<EventKind, string> = {
  tournament: "Турнир",
  training: "Тренировка",
  challenge: "Вызов",
};

export const PLACE_COLOR: Record<PlaceType, string> = {
  outdoor_spot: "#FF5A1F",
  indoor_hall: "#1E7A5A",
  store: "#2481CC",
};

export const PLACE_COLOR_SOFT: Record<PlaceType, string> = {
  outdoor_spot: "rgba(255,90,31,0.12)",
  indoor_hall: "rgba(30,122,90,0.14)",
  store: "rgba(36,129,204,0.14)",
};
